<rt-icons-container />

<rtc-detached-router-outlet />
